export const defaultVatRatesPredefinedTags: { [countryCode: string]: string } = {
  FR: 's_fr_200',
}
